import axios from '@/core/axios';

import { ItemStatement } from './item-statements.types';

export class ItemStatementsService {
  get(device_id: number): Promise<ItemStatement[]> {
    if (!device_id) throw new Error('Missing device_id in get');
    return axios.get<ItemStatement[]>(`/item-statements/${device_id}`).then(resp => resp?.data);
  }

  getWithCancel(device_id: number): Promise<ItemStatement[]> {
    if (!device_id) throw new Error('Missing device_id in get');
    return axios.post<ItemStatement[]>(`/item-statements/${device_id}`, { with_cancel: true }).then(resp => resp?.data);
  }

  create(item_statement: ItemStatement[]): Promise<ItemStatement> {
    return axios
      .post<ItemStatement>('item-statements', { item_statement })
      .then(resp => {
        return resp?.data;
      })
      .catch(error => {
        console.error('Error during the creation of item_statement: ', error);
        throw error;
      });
  }

  async update(item_statement: Partial<ItemStatement>): Promise<ItemStatement> {
    if (!item_statement) throw new Error('Missing item in update');

    const resp = await axios.put<ItemStatement>(`item-statements/update`, { item_statement });
    return resp?.data;
  }

  async delete(itemStatementId: number): Promise<ItemStatement> {
    if (!itemStatementId) throw new Error('Missing id in delete');

    const resp = await axios.delete<ItemStatement>(`item-statements/${itemStatementId}/delete`);
    return resp?.data;
  }
}

export const itemStatementsService = new ItemStatementsService();
